module.exports = __webpack_public_path__ + "static/media/passportEnrollment.5208635c.svg";